module.exports = __webpack_public_path__ + "media/images/marketing/weight_loss_icon-8237c82e0c9928bc319068fa8472fddcbc87b675da607b655ad9b2de94f6347e.svg";